export const NUMBER_OF_NOTIFICATIONS_TO_LOAD = 10
export const PROMOTION_NOTIFICATION_CONTENT_TYPE = 'promotion-notification-center'
